import classNames from 'classnames';
import { BtnThreeProps } from 'eco-design-micro/props/btn/BtnThreeProps';
import { ImgHeightProps } from 'eco-design-micro/props/const';
import { ImgVideoProps } from 'eco-design-micro/props/img/ImgVideoProps';
import { SectionAllLayout } from 'eco-design-micro/props/msg/const';
import { SectionTextWithColorProps } from 'eco-design-micro/props/msg/SectionTextProps';
import EcoButtonThree from 'eco-design/base/eco-button-three';
import EcoImgVideo from 'eco-design/base/eco-img-video';
import EcoSection from 'eco-design/base/eco-section';
import React from 'react';
import './index.scss';

export interface EcoSectionCardProps extends ImgVideoProps, SectionTextWithColorProps, BtnThreeProps {
    /**
     * 主题色
     */
    theme?: 'black' | 'white';

    /**
     * 文案展示位置
     */
    layout?: SectionAllLayout;

    /**
     * 高度类型
     *
     * default 默认固定高度
     *
     * full-screen 满屏
     */
    heightType?: 'default' | 'full-screen';

    /**
     * 图片容器高度
     *
     * 5-3
     *
     * 1-1
     *
     * 4-3
     *
     * 16-9
     */
    imgHeight?: ImgHeightProps;

    /**
     * 样式名
     */
    className?: string;
}

/**
 *
 * 通用段落
 */
const EcoSectionCard: React.FC<EcoSectionCardProps> = ({ className, ...reset }) => {
    const props = reset || {};
    const prefixCls = `eco-section-card`;
    const theme = props.theme || 'white';
    const heightType = props.heightType || 'default';
    const imgHeight = props.imgHeight || '1-1';
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-layout-${props.layout}`]: props.layout,
        [`${prefixCls}-theme-${theme}`]: theme,
        [`${prefixCls}-heightType-${heightType}`]: heightType,
        [`${prefixCls}-imgHeight-${imgHeight}`]: imgHeight,
    });

    return (
        <div className={classes}>
            <div className={`${prefixCls}-img`}>
                <EcoImgVideo {...props} />
            </div>
            <div className={`${prefixCls}-msg`}>
                <div className={`${prefixCls}-in`}>
                    <EcoSection {...props} />
                    <EcoButtonThree {...props} className={`${prefixCls}-btn-box`} />
                </div>
            </div>
        </div>
    );
};

export default EcoSectionCard;
